"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CardResultsTable = (props) => {
    const { data, count, cardType } = props;
    const CardTypeComponent = cardType;
    const noResultsInfo = props.noResultsInfo || react_1.default.createElement("p", { className: 'small no-results bold' }, "No results");
    return react_1.default.createElement(react_1.default.Fragment, null, count > 0 ? data.map((item) => react_1.default.createElement(CardTypeComponent, Object.assign({}, item, { key: item.getId() }))) : noResultsInfo);
};
exports.default = CardResultsTable;
